import Vue from "vue";
require("../config.js");

const Map = {
    namespaced: true,
    state: {
        configlayers: {
            resolutions: [
                156543.03392804103,
                78271.5169640205,
                39135.75848201024,
                19567.879241005125,
                9783.939620502562,
                4891.969810251281,
                2445.9849051256406,
                1222.9924525628203,
                611.4962262814101,
                305.74811314070485,
                152.87405657035254,
                76.43702828517625,
                38.218514142588134,
                19.109257071294063,
                9.554628535647034,
                4.777314267823517,
                2.3886571339117584,
                1.1943285669558792,
                0.5971642834779396,
                0.29858214173896974,
                0.14929107086948493,
                0.07464553543474241
            ],
            matrixSet: 'EPSG:4326',
        },
        // current map viewport (shared among all vuelayers instances)
        view: {
            ident: 'shared-view', // https://vuelayers.github.io/#/component/view?id=ident
            zoom: 8,
            extent: undefined,
            rotation: 0,
            center: [5.330961, 43.491699],
        },
        layers: [

            {
                text: 'Epci',
                layerName: "EPCI",
                opacity: 1,
                checked: false,
                baseLayer: false,
                format: 'image/png',
                map: window.mapFile,
                type: 'mapserver',
                projection: 'EPSG:900913',
                url: window.url_mapServer,
                zindex: 15
            },
            {
                text: 'Communes',
                layerName: "COMMUNES",
                opacity: 1,
                checked: false,
                baseLayer: false,
                format: 'image/png',
                map: window.mapFile,
                type: 'mapserver',
                projection: 'EPSG:900913',
                url: window.url_mapServer,
                zindex: 11
            },
            {
                text: 'Départements',
                layerName: "DEPARTEMENTS",
                opacity: 1,
                checked: false,
                baseLayer: false,
                format: 'image/png',
                map: window.mapFile,
                type: 'mapserver',
                projection: 'EPSG:900913',
                url: window.url_mapServer,
                zindex: 11
            },
            {
                text: 'Zone des opérations',
                layerName: "OPERATIONS",
                opacity: 1,
                checked: false,
                baseLayer: false,
                format: 'image/png',
                map: window.mapFile,
                type: 'mapserver',
                projection: 'EPSG:900913',
                url: window.url_mapServer,
                zindex: 12
            },
            {
                text: 'Parcelles',
                layerName: "CADASTRALPARCELS.PARCELS",
                opacity: 0.5,
                checked: false,
                baseLayer: false,
                format: 'image/png',
                matrix: 'PM',
                type: 'IGN',
                zindex: 8,
                url: 'https://data.geopf.fr/wmts',
            },
            {
                text: 'Routes',
                layerName: "TRANSPORTNETWORKS.ROADS",
                opacity: 0.5,
                checked: false,
                baseLayer: false,
                format: 'image/png',
                matrix: 'PM',
                type: 'IGN',
                zindex: 8,
                url: 'https://data.geopf.fr/wmts',
            },
            {
                text: 'Photo Aérienne',
                layerName: "ORTHOIMAGERY.ORTHOPHOTOS",
                opacity: 0.8,
                checked: true,
                baseLayer: true,
                format: 'image/jpeg', //,                legend: null
                matrix: 'PM',
                type: 'IGN',
                zindex: 1,
                url: 'https://data.geopf.fr/wmts',
            },
            {
                text: 'Plan',
                layerName: "GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2",
                opacity: 0.8,
                checked: false,
                baseLayer: true,
                format: 'image/png', //,                legend: null,
                matrix: 'PM',
                type: 'IGN',
                zindex: 1,
                url: 'https://data.geopf.fr/wmts',
            },
            {
                text: 'OpenStreetMap',
                layerName: "OSM",
                opacity: 0.8,
                checked: false,
                baseLayer: true,
                format: 'image/jpeg', //,                legend: null,
                matrix: 'PM',
                zindex: 1,
                type: 'OSM'
            },
        ]
    },
    actions: {
        setExtent(context, extent) {
            context.commit('SETEXTENT', extent);
        },
        showBaseLayer(context, name) {
            context.commit('SHOWBASELAYER', name);
        },
        updateViewZoom(context, zoom) {
            context.commit('updateViewZoom', zoom);
        },
        updateViewCenter(context, lnglat) {
            context.commit('updateViewCenter', lnglat);
        },
        updateViewRotation(context, lnglat) {
            context.commit('updateViewRotation', lnglat);
        },
        addToLayerList(context, layers) {
            context.commit('addToLayerList', layers);
        },
    },
    mutations: {
        SETSELECTEDFEATURES(state, features) {
            state.selectedFeatures = features;
        },
        SETEXTENT(state, extent) {
            state.view.extent = extent; // eslint-disable-line no-param-reassign
        },
        SHOWBASELAYER(state, name) {
            state.layers.forEach(function (layer) {
                if (layer.baseLayer === true) {
                    layer.checked = false;
                }
            });
            let layer = state.layers.find(layer => layer.layerName === name);
            if (layer != null) {
                layer.checked = true
            }
        },
        updateViewZoom(state, zoom) {
            state.view.zoom = zoom; // eslint-disable-line no-param-reassign
        },
        updateViewCenter(state, lnglat) {
            state.view.center = lnglat; // eslint-disable-line no-param-reassign
        },
        addToLayerList(state, layers) {
            layers.forEach((layer) => {
                if (!state.layers[layer.id]) {
                    Vue.set(state.layers, layer.id, layer);
                }
            });
        },
        updateViewRotation(state, rotation) {
            state.view.rotation = rotation;
        }
    },
    getters: {
        selectedFeatures: state => {
            return state.selectedFeatures;
        },
        layers: state => {
            return state.layers.filter(layer => layer.baseLayer === false);
        },
        baseLayers: state => {
            return state.layers.filter(layer => layer.baseLayer === true);
        },
        allLayers: state => {
            return state.layers;
        },
        center: state => {
            return state.view.center;
        },
        zoom: state => {
            return state.view.zoom;
        },
        rotation: state => {
            return state.view.rotation
        },
        extent: state => {
            return state.view.extent
        },
        configlayers: state => {
            return state.configlayers;
        }
    },
};
export default Map